module.exports = __webpack_public_path__ + "assets/aea6178e-a137-430d-9ebb-265f36bc6380.a92f122c.svg";